import { render } from "./affiliateList.vue?vue&type=template&id=41e1bc0e"
import script from "./affiliateList.vue?vue&type=script&lang=js"
export * from "./affiliateList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__